/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (max-width:1024px){a[mat-tab-link][_ngcontent-%COMP%]{font-size:12px;padding:0 10px}}"];
export { styles as styles };
